import type { ReactNode } from 'react'

const RESOURCES = ['nectar', 'pollen', 'honey', 'wax', 'propolis']
const RESOURCE_PATTERN = new RegExp(
  `(${RESOURCES.map((r) => r[0].toUpperCase() + r.slice(1)).join('|')})`,
  'g'
)

export function formatGameMessage(
  message: string,
  aliasByColor: Record<string, string>
): ReactNode[] {
  const chunks = message.split(/(\{.*?})/)
  const rendered: ReactNode[] = []

  for (const chunk of chunks) {
    if (!chunk) continue

    if (chunk.startsWith('{') && chunk.endsWith('}')) {
      const color = chunk.slice(1, -1)
      rendered.push(
        <span key={`${color}-${rendered.length}`} style={{ color: `var(--${color})`, fontWeight: 'bold' }}>
          {aliasByColor[color] ?? color}
        </span>
      )
      continue
    }

    const resourceChunks = chunk.split(RESOURCE_PATTERN)
    for (const part of resourceChunks) {
      if (!part) continue
      if (RESOURCES.includes(part.toLowerCase())) {
        rendered.push(
          <span key={`res-${part}-${rendered.length}`} style={{ color: 'var(--yellow)', fontWeight: 'bold' }}>
            {part}
          </span>
        )
      } else {
        rendered.push(part)
      }
    }
  }

  return rendered
}

export function plainGameMessage(message: string, aliasByColor: Record<string, string>): string {
  return message.replace(/\{([^}]+)\}/g, (_, color) => aliasByColor[color] ?? color)
}
